export const muiStyles = () => ({
    flexColumn: {
        display: 'flex',
        flexFlow: 'column nowrap'
    },
    submitButton: { width: 'auto' as 'auto' },
    submitButtonContainer: {
        marginTop: '2.5rem',
        marginBottom: '2rem'
    },
    submitError: { alignSelf: 'center' }
});